import Ontology from './ontology';

const LINK_VIEW_DELIMITER = ' — '; // это не минус, это длинное тире!

class Model {

	constructor(url) {
		this.url = url;
	}

	setLoadListener(listener) {
		this.listener = listener;
	}

	fireLoadStart() {
		if (this.listener) {
			this.listener.loadStart();
		}
	}

	fireLoadDone() {
		if (this.listener) {
			this.listener.loadDone();
		}
	}

	fireLoadError(error) {
		if (this.listener) {
			this.listener.loadError(error);
		}
	}
	
	trim(elem) {
		if (typeof elem === 'string') {
			elem = elem.trim();
		} else if (this.isArray(elem)) {
			for (let i = 0; i < elem.length; i++) {
				elem[i] = this.trim(elem[i]);
			}
		} else if (elem instanceof Object) {
			for (let key in elem) {
				if (elem.hasOwnProperty(key)) {
					elem[key] = this.trim(elem[key]);
				}
			}
		}
		return elem;
	}

	api(method, params) {
		params    = this.trim(params);
		const req = {method: method, params: params};
		this.fireLoadStart();
		return fetch(this.url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept':       'application/json',
				'Authorization': `Basic ${btoa(`admin@semanticpro.org:qfYXPSdnGqYje5`)}`
				//'Cookie': 'JSESSIONID=13F3112718BF31F750E2CE4E553183DE;'

			},
			body: JSON.stringify(req)
		})
			// check http response
			.then(res => {
				if (res.ok) {
					return res;
				}
				throw 'http: ' + res.status + ' ' + res.statusText;
			})
			// convert to json
			.then(res => res.json())
			// check json-rpc response
			.then(res => {
				if (res.error) {
					throw res.error;
				}
				if (! res.result) {
					throw 'rpc: empty result';
				}
				return res.result;
			})
			.then(res => {
				this.fireLoadDone();
				return res;
			})
			.catch(error => {
				this.fireLoadError(error);
			});
	} 

	getOntology() {
		return this.testResponse(Ontology);
	}
	
	testResponse(res) {
		return new ModelPromise(res, this);
	}

	getAssets() {
		return this.api('asset.list', []);
	}

	getGraphs(endpoint) {
		return this.api('graph.list', [endpoint]);
	}

	/**
	Возвращает список view c минимальным 
	набором данных (id, type, name, description)
	*/
	getViews(asset_id) {
		return this.api('view.list', [asset_id]);
	}

	clearViews(asset_id) {
		return this.api('view.clear', [asset_id]);
	}

	/** 
	Возвращает view c полным набором данных 
	Это (id, name, description) + вся остальная конфигурация
	*/
	getView(view_id) {
		return this.api('view.get', [view_id]);
	}

	getLinkedView(linked) {
		const params = [this.isArray(linked) ? this._getLinkedViewId(linked[0]) : linked];
		return this.api('view.getLinked', params);
	}

	getAvailableLinkViewColumnList() {
		return this.api('view.getAvailableLinkViewColumnList', [])
			.then(response => {
				const cols = response.view.link_view_columns;
				cols.forEach(c => {
					let id = [c.id];
					if (c.hasOwnProperty('mv_id')) {
						id.push(c.mv_id);
					}
					if (c.hasOwnProperty('col_field')) {
						id.push(c.col_field);
					}
					c.id = id.join(LINK_VIEW_DELIMITER);
				});
				return cols;
			});
	}

	getLinkViewName(c) {
		let n = [c.asset_id, c.view_title];
		if (c.hasOwnProperty('mv_view_title')) {
			n.push(c.mv_view_title);
		}
		if (c.hasOwnProperty('col_field')) {
			n.push(c.col_field);
		}
		return n.join(LINK_VIEW_DELIMITER);
	}

	getLinkedColumn(linked) {
		if (this.isArray(linked)) {
			return linked;
		} else {
			return linked.split(LINK_VIEW_DELIMITER).pop();
		}
	}

	getLinkedColumnByViewId(viewId, cols) {
		for (let i = 0; i < cols.length; i++) {
			const col = cols[i];
			if (this._getMultiLinkedViewId(col) === viewId) {
				return this.getLinkedColumn(col);
			}
		}
	}

	_getLinkedViewId(linked) {
		return linked.split(LINK_VIEW_DELIMITER).shift();
	}

	_getMultiLinkedViewId(linked) {
		return linked.split(LINK_VIEW_DELIMITER)[1];
	}

	isArray(arg) {
		return Object.prototype.toString.call(arg) === '[object Array]';
	}

	getAvailableViewList() {
		return this.api('view.getAvailableViewList', [])
			.then(response => {
					const assetViews = response.view.views;
					let v = [];
					for (let assetId in assetViews) {
						assetViews[assetId].forEach(view => {
							v.push({
								asset_id: assetId,
								view_title: view.view_title,
								id: view.id
							});
						});
					}
					return v;
				}
			);
	}

	getAvailableAssetList() {
		return this.getAssets()
			.then(response => {
				response.list.forEach(a => {
					a.name = [a.id, a.name].join(LINK_VIEW_DELIMITER)
				});
				return response.list;
			});
	}

	getAvailableGraphList(endpoint) {
		return this.getGraphs(endpoint)
			.then(response => {
				response.list.forEach(a => {
					a.name = a.id
				});
				return response.list;
			});
	}

	// отличить insert/update можно по наличию view.id
	saveView(view) {
		return this.api('view.save', [view]);
	}

	// удалить view
	deleteView(view_id) {
		return this.api('view.delete',[view_id]);
	}

	copyView(view_id) {
		return this.api('view.copy', [view_id]);
	}

	getData(view_id, offset, filter, cmp_graph) {
		return this.api('data.get', [view_id, offset, filter, cmp_graph]);
	}

	getTreeData(view_id, offset, level, parent_id) {
		const params = [view_id, offset, level || 0];
		if (parent_id) {
			params.push(parent_id);
		}
		return this.api('data.gettree', params);
	}

	/** 
	Получить описание результата SparQL запроса
	Возвращает массив объектов с описанием колонок
	В описании имя колонки и пример значения
	*/ 
	getColumns(endpoint, query) {
		return this.api('view.getColumns', [endpoint, query]);
	}

    /**
    Получение просмотра для экспорта
    */
    getExport(view_id) {
		return this.api('export.get', [view_id]);
	}

} 

export default Model;

class ModelPromise {

  constructor(response, eventDispatcher) {
	this.response = response;
	this.events   = eventDispatcher;
	this.state    = 'init';
	this._then    = null;
	this._catch   = null;
	this.events.fireLoadStart();
	this.timer = setTimeout(() => {
	  this.events.fireLoadDone();
	  this.received()
	}, 2000)
  }

  received() {
	this.state = 'ready';
	this.pass()
  }

  pass() {
	if(this.state === 'ready' && this._then){
	  this.state = 'pass';
	  this._then(this.response)
	}
  }

  then(callback) {
	this._then = callback;
	this.pass();
	return this;
  }

  catch(callback) {
	this._catch = callback;
	return this;
  }

}
